import styled from 'styled-components'
import { Button as DefaultButton } from '~/shared/ui/Buttons'
import { myPalette } from '~/shared/ui/theme'

export const Button = styled(DefaultButton)`
  position: absolute;
  left: 12px;
  bottom: 17px;
  display: flex;
  width: auto;
  padding: 0;
  color: ${myPalette.midnightBlue.main};
`

export const TextButton = styled.div`
  background-color: ${myPalette.white.main};
  border-radius: 40px;
  padding: 6px 8px;
  font-size: 12px;
  margin-right: 8px;
  font-weight: 500;
`

export const IconButton = styled.div`
  background-color: ${myPalette.white.main};
  border-radius: 50%;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
`
